module.exports = __webpack_public_path__ + "img/1576274983.9cbd453c.jpg";